<td class="font-bold">{{ dayText }}</td>
<td class="text-center">
  <p-checkbox
    [(ngModel)]="isOpen"
    (onChange)="onIsOpenChange($event)"
    binary="true"
    [disabled]="disableFields"
  ></p-checkbox>
</td>
<td>
  <!--  <p-dropdown-->
  <!--    [options]="hourSelectItems"-->
  <!--    [formControl]="openTimeFormControl"-->
  <!--    (onChange)="openChange($event)"-->
  <!--  ></p-dropdown>-->
  <p-calendar
    [inputStyle]="{ width: '65px' }"
    [inputStyleClass]="'border-validation'"
    placeholder="00:00"
    [defaultDate]="defaultDate"
    [formControl]="formGroup.controls.open"
    [timeOnly]="true"
    [showSeconds]="false"
    readonlyInput="true"
    [stepMinute]="30"
    (onInput)="openChange($event)"
    (onClose)="hideOpenOverlay()"
    #openTime
    [disabled]="disableFields"
  ></p-calendar>
</td>
<td>
  <p-calendar
    [inputStyle]="{ width: '65px' }"
    placeholder="00:00"
    [defaultDate]="defaultDate"
    [formControl]="formGroup.controls.close"
    [timeOnly]="true"
    [showSeconds]="false"
    readonlyInput="true"
    [stepMinute]="30"
    (onInput)="closeChange($event)"
    (onClose)="hideCloseOverlay()"
    #closeTime
    [disabled]="disableFields"
  ></p-calendar>
</td>
